// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "zxing" + "." + "c17af3e9" + ".js";
};